import { useTranslation } from 'react-i18next'

const useTranslate = () => {
  return useTranslation()
}

export default useTranslate